import { TerminalTaskFormPayload } from 'aos-services/src/services/tasks/types/payload/TerminalTaskFormPayload'
import {
    allTerminalTaskTypes,
    TerminalTaskType,
    translateTerminalTaskType,
} from 'aos-services/src/services/tasks/types/task/TerminalTask'
import { TaskMetadata } from 'aos-services/src/services/tasks/types/TaskMetadata'
import React from 'react'
import { Controller, useController, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { terminalTaskTypeIcon } from '../../../utils'
import { TaskFormField } from '../TaskFormField'
import { TaskOptionChip } from '../TaskOptionChip'
import { TaskTextField } from './partials/TaskTextField'

interface TerminalTaskFormProps {
    metadata: TaskMetadata
    isTaskTemplate: boolean
}

export const TerminalTaskForm: React.FC<TerminalTaskFormProps> = ({ isTaskTemplate }) => {
    const { t: translate } = useTranslation()
    const { control } = useFormContext<TerminalTaskFormPayload>()
    const payload = useWatch({ control }) as TerminalTaskFormPayload
    const titleField = useController({ name: 'title', control })

    return (
        <>
            <Controller
                control={control}
                name='terminalTaskType'
                render={({ field, fieldState }) => (
                    <TaskFormField
                        label={translate('form.terminal-task-type.label', { ns: 'tasks' })}
                        required={!isTaskTemplate}
                        error={
                            fieldState.error
                                ? translate('form.terminal-task-type.error', { ns: 'tasks' })
                                : undefined
                        }
                        seleniumLocation='category'
                    >
                        <div className='grid grid-cols-4 gap-2'>
                            {allTerminalTaskTypes.map(item => (
                                <TaskOptionChip
                                    key={item}
                                    orientation='vertical'
                                    icon={terminalTaskTypeIcon[item]}
                                    label={translateTerminalTaskType(translate)(item)}
                                    isSelected={field.value === item}
                                    onPress={() => {
                                        field.onChange(item)
                                        titleField.field.onChange(
                                            translateTerminalTaskType(translate)(item),
                                        )
                                    }}
                                />
                            ))}
                        </div>
                    </TaskFormField>
                )}
            />
            {payload.terminalTaskType === TerminalTaskType.HeatingWires && (
                <>
                    <Controller
                        name='licensePlate'
                        control={control}
                        render={({ field, fieldState }) => (
                            <TaskTextField
                                keyPrefix='tasks.form.terminal.license-plate'
                                required={!isTaskTemplate}
                                error={
                                    fieldState.error
                                        ? translate('form.terminal.license-plate.error', {
                                              ns: 'tasks',
                                          })
                                        : undefined
                                }
                                seleniumLocation='licensePlate'
                                value={field.value}
                                onChangeText={field.onChange}
                            />
                        )}
                    />
                    <Controller
                        name='vehicleLocation'
                        control={control}
                        render={({ field, fieldState }) => (
                            <TaskTextField
                                keyPrefix='tasks.form.terminal.vehicle-location'
                                error={
                                    fieldState.error
                                        ? translate('form.terminal.vehicle-location.error', {
                                              ns: 'tasks',
                                          })
                                        : undefined
                                }
                                seleniumLocation='vehicleLocation'
                                value={field.value}
                                onChangeText={field.onChange}
                            />
                        )}
                    />
                </>
            )}
            {payload.terminalTaskType === TerminalTaskType.CUSSParkingMeters && (
                <>
                    <Controller
                        name='paperSupplement'
                        control={control}
                        render={({ field, fieldState }) => (
                            <TaskTextField
                                keyPrefix='tasks.form.terminal.paper-supplement'
                                error={
                                    fieldState.error
                                        ? translate('form.terminal.paper-supplement.error', {
                                              ns: 'tasks',
                                          })
                                        : undefined
                                }
                                seleniumLocation='paperSupplement'
                                value={field.value}
                                onChangeText={field.onChange}
                            />
                        )}
                    />
                    <Controller
                        name='observation'
                        control={control}
                        render={({ field, fieldState }) => (
                            <TaskTextField
                                keyPrefix='tasks.form.terminal.observation'
                                error={
                                    fieldState.error
                                        ? translate('form.terminal.observation.error', {
                                              ns: 'tasks',
                                          })
                                        : undefined
                                }
                                seleniumLocation='observation'
                                value={field.value}
                                onChangeText={field.onChange}
                            />
                        )}
                    />
                </>
            )}
        </>
    )
}
